import { Box, getVariant, Select } from '@apia/theme';
import { getLabel } from '@apia/util';
import PermissionsList from './PermissionsList';
import { observer } from 'mobx-react-lite';
import { UserModalBtn } from './modals/UserModalBtn';
import { PoolModalBtn } from './modals/PoolModalBtn';
import { createContext, useContext } from 'react';
import { CollapsiblePanel } from '../collapsiblePanel';

export type TPickUserForPermissions = {
  userId: string;
  userLogin: string;
  canUpdate: boolean;
};

export type TPickPoolForPermissions = {
  poolId: string;
  poolName: string;
  canUpdate: boolean;
};

type TPermissionsContext = {
  disabled?: boolean;
  onChangePools: (u: TPickPoolForPermissions[]) => unknown;
  onChangeUsers: (u: TPickUserForPermissions[]) => unknown;
  permissions: {
    pools: TPickPoolForPermissions[];
    users: TPickUserForPermissions[];
  };
};

const PermissionsContext = createContext<null | TPermissionsContext>(null);
export function usePermissionsContext() {
  return useContext(PermissionsContext)!;
}

export const Permissions = observer(
  ({
    everyonePermissionsValue,
    collapsePermissions,
    disabled,
    onChangeEveryonePermissions,
    onChangeUsers,
    onChangePools,
    permissions,
  }: TPermissionsContext & {
    everyonePermissionsValue: 'R' | 'M' | '';
    collapsePermissions?: boolean;
    onChangeEveryonePermissions: (value: 'R' | 'M' | '') => unknown;
  }) => {
    return (
      <CollapsiblePanel
        label={<span>{getLabel('lblPer').text}</span>}
        id="permissions"
        collapseIconToRight
        closedIcon="ArrowUpThin"
        openIcon="ArrowDownThin"
        className="uploader__permissions"
        collapsed={collapsePermissions}
      >
        <PermissionsContext.Provider
          value={{
            onChangeUsers,
            onChangePools,
            permissions,
            disabled,
          }}
        >
          <Box {...getVariant('layout.common.components.uploader.permissions')}>
            <label className="uploader__permissions_selection">
              <Box>
                <span>{getLabel('lblTod').text}</span>
                <Select
                  disabled={disabled}
                  onChange={(ev) => {
                    onChangeEveryonePermissions(
                      ev.target.value as 'R' | 'M' | '',
                    );
                  }}
                  value={everyonePermissionsValue}
                >
                  <option value="M">{getLabel('lblPerMod').text}</option>
                  <option value="R">{getLabel('lblPerVer').text}</option>
                  <option value={''}>{getLabel('lblAccessDenied').text}</option>
                </Select>
              </Box>
              <UserModalBtn />
              <PoolModalBtn />
            </label>
            <PermissionsList />
          </Box>
        </PermissionsContext.Provider>
      </CollapsiblePanel>
    );
  },
);
